/* eslint-disable */
//Category
import Category from "@/views/Category.vue";
import categoryIndex from "@/components/category/Index.vue";
import categoryAdd from "@/components/category/Add.vue";

//Middleware
import isLogin from "@/middleware/AuthMiddleware.js";

export default {
    path: "/category",
    component: Category,
    children:[
      {
        path:'/',
        name: "category",
        component:categoryIndex,
        meta:{
          parent: "category",
          title: "Kategori",
          navbar:true,
          middleware:[
            isLogin,
          ]
        },
      },
      {
        path:'add',
        component:categoryAdd,
        name: 'category.add',
        meta:{
          parent: "category",
          title: "Tambah Kategori",
          navbar:true,
          middleware:[
            isLogin,
          ]
        }
      },
      {
        path:'edit/:id',
        component:categoryAdd,
        name:"category.edit",
        meta:{
          parent:"category",
          navbar:true,
          middleware:[
            isLogin,
          ]
        }
      }
    ]
  }